import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VuePdfApp from 'vue-pdf-app';
// import this to use default icons for buttons
import 'vue-pdf-app/dist/icons/main.css';
export default {
  components: {
    VuePdfApp: VuePdfApp
  },
  data: function data() {
    return {
      pdfUrl: null,
      pdfDoc: null,
      // pdfjs 生成的对象
      pageRendering: false,
      activeNum: 0,
      instID: 0,
      fileID: 0,
      institution: null,
      fileidarr: [],
      input: '',
      filename: null,
      instList: [],
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      pdfloading: true,
      // 加载进度
      loadedRatio: 0,
      curPageNum: 0,
      src: null,
      numPages: undefined,
      pdfApp: null,
      percentage: 0,
      customColor: 'var(--mainColor)',
      checked: false,
      pdfViewer: null,
      config: {
        sidebar: false,
        secondaryToolbar: false,
        toolbar: {
          toolbarViewerLeft: {
            findbar: true,
            previous: true,
            next: true,
            pageNumber: true
          },
          toolbarViewerRight: false,
          toolbarViewerMiddle: true
        }
      },
      qsburl: '',
      helpDocID: 0,
      isNomal: this.$route.query.nomal
    };
  },
  created: function created() {
    if (this.$route.query) {
      this.helpDocID = this.$route.query.helpDocId || 1;
    }
    this.getAllFileList();
  },
  mounted: function mounted() {
    var highligehtallcheck = document.getElementById('findHighlightAll');
    highligehtallcheck.setAttribute('checked', 'checked');
    var findbarOptionsTwoContainer = document.getElementById('findbarOptionsTwoContainer');
    findbarOptionsTwoContainer.parentNode.removeChild(findbarOptionsTwoContainer);
    var elem = document.getElementById('findInput');
    elem && elem.setAttribute('autocomplete', 'off');
  },
  methods: {
    getAllFileList: function getAllFileList() {
      var _this = this;
      this.$API.getRequest({
        // eslint-disable-next-line no-useless-concat
        url: '/platform/helpDoc/download?' + "id=".concat(this.helpDocID, "&download=0"),
        responseType: 'blob'
      }).then(function (res) {
        // if (res.code === '0000000000') {
        var blob = new Blob([res.data], {
          type: 'application/pdf'
        });
        var bloburl = window.URL.createObjectURL(blob);
        _this.qsburl = bloburl;
        // } else {
        _this.pdfloading = false;
        // }
      });
    },
    openHandler: function openHandler(pdfApp) {
      this.pdfloading = false;
      this.pdfApp = pdfApp;
      var findinput = document.getElementById('findInput');
      findinput.addEventListener('input', function () {
        pdfApp.pdfViewer.currentPageNumber = 1;
      });
      pdfApp.pdfViewer.currentScaleValue = 'page-width';
    }
  }
};